import { connect } from 'react-redux'

import { MessageBubble as BaseMessageBubble } from './MessageBubble'
import {
  fetchAttachmentThumbnail,
  downloadAttachment,
} from 'store/MemberCommunication'

const mapStateToProps = ({ Member, MemberCommunication }) => ({
  attachmentThumbnails: MemberCommunication.attachmentThumbnails.entities,
  error: MemberCommunication.attachmentThumbnails.error,
  members: Member.members?.entities,
  busy: MemberCommunication.attachmentThumbnails.busy,
  downloadAttachmentError: MemberCommunication.attachment.error,
  downloadAttachmentBusy: MemberCommunication.attachment.busy,
})

const mapDispatchToProps = {
  fetchAttachmentThumbnail,
  downloadAttachment,
}

export const MessageBubble = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BaseMessageBubble)
